var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel-field" },
    [
      _c(
        "label",
        { staticClass: "contactum-label" },
        [
          _vm._v("\n    " + _vm._s(_vm.field.title) + "\n    "),
          _c("el-input", {
            attrs: { type: "text" },
            on: { focusout: _vm.onfocusout, keyup: _vm.onkeyup },
            model: {
              value: _vm.value,
              callback: function($$v) {
                _vm.value = $$v
              },
              expression: "value"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("merge_tags", {
        attrs: { filter: _vm.field.tag_filter },
        on: { insert: _vm.insertValue }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }